// Audit log domain types aligned with BE wire shape.

export interface AuditActor {
  id: string;
  email?: string | null;
  username?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export interface AuditOrgSummary {
  id: string;
  name: string;
  slug: string;
}

export interface AuditResourceSummary {
  id: string;
  type: string;
  name: string;
  subtitle?: string | null;
  deleted?: boolean;
}

export interface AuditPrincipalSummary {
  kind: "user" | "group" | "role" | string;
  id?: string | null;
  role?: string | null;
  name: string;
  email?: string | null;
  groupType?: string | null;
}

export function resolveActorLabel(
  actor: AuditActor | null | undefined,
  fallback: string,
): string {
  if (actor) {
    const name = `${actor.firstName ?? ""} ${actor.lastName ?? ""}`.trim();
    if (name) return name;
    if (actor.username) return actor.username;
    if (actor.email) return actor.email;
  }
  return fallback;
}

export type AuditSource =
  | "owner_bypass"
  | "admin_bypass"
  | "denied_no_grant"
  | "denied_by_grant"
  | "direct_grant"
  | "inherited"
  | string;

export interface AuditEntry {
  id: string;
  orgId: string;
  actorUserId?: string | null;
  actorApiKeyId?: string | null;
  actionKey: string;
  action?: string | null;
  args?: Record<string, unknown> | null;
  source?: AuditSource | null;
  resourceType?: string | null;
  resourceId?: string | null;
  humanizedSummary?: string | null;
  createdAt: string;
  actor?: AuditActor | null;
  org?: AuditOrgSummary | null;
  resource?: AuditResourceSummary | null;
  principal?: AuditPrincipalSummary | null;
}

export interface AuditListFilter {
  actor?: string;
  actionKey?: string[];
  source?: string[];
  resourceType?: string[];
  resourceId?: string;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}

export interface AuditListPage {
  items: AuditEntry[];
  nextPage?: number | null;
  total?: number;
}
